import { CourseRouteName } from "@/pages/courses/route";
import { CourseDetailRouteName } from "@/pages/courses/route/course";
import type { RouteRecordRaw } from "vue-router";

export const technicianRoutes: RouteRecordRaw[] = [
  {
    path: "technician/nailjob/:id",
    name: "job-detail",
    component: () => import("@/pages/job/job-detail.vue")
  },
  {
    path: "technician/nailtech/:id",
    name: "profile-detail",
    component: () => import("@/pages/worker/profile-detail.vue")
  },
  {
    path: "technician/salon-sale/:id",
    name: "salon-sale-detail",
    component: () => import("@/pages/salon-sale/salon-detail.vue")
  },
  CourseDetailRouteName(),
  {
    path: "technician",
    component: () => import("@/layouts/tech.vue"),
    redirect: { name: "nail-job" },
    children: [
      {
        path: "",
        name: "technician-home",
        redirect: { name: "nail-job" }
      },
      {
        path: "nailjob",
        name: "nail-job",
        component: () => import("@/pages/job/index.vue")
      },
      {
        path: "nailtech",
        name: "nail-tech",
        component: () => import("@/pages/worker/index.vue")
      },
      {
        path: "salon-sale",
        name: "salon-sale",
        component: () => import("@/pages/salon-sale/index.vue")
      },
      CourseRouteName()
    ]
  }
];
